<!-- @format -->
<script lang="ts">
  import { slide } from "svelte/transition";
  export let showDropdown = false;
  function closeDropDown() {
    if (showDropdown) showDropdown = false;
  }
</script>

<svelte:body on:click|stopPropagation={closeDropDown} />
<!-- svelte-ignore a11y-click-events-have-key-events -->
<div
  class="dropdown-wrapper mb-5"
  on:click={() => {
    showDropdown = true;
  }}>
  <button
    class="form-control input-with-icon"
    on:click|stopPropagation={() => {
      showDropdown = !showDropdown;
    }}>
    <slot name="default-value" />
    <img
    src="/theme/citycon2023/images/arrow-down-black.png"
    width="32"
    class="icon-in-input"
    alt="arrow down" />
  </button>

  {#if showDropdown}
    <div class="select-items" transition:slide|local>
      <slot name="options" />
    </div>
  {/if}
</div>

<style lang="scss">
  .dropdown-wrapper {
    cursor: pointer;
    position: relative;
  }
  .input-with-icon {
    height: auto;
    padding: 0.625rem 0;
    background-color: var(--color-white);
    border: none;
    border-bottom: 1px solid #000;
    border-radius: 0;
    text-align: left;
  }
  .icon-in-input {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translate(0, -50%);
  }

  .select-items {
    position: absolute;
    background-color: var(--color-white);
    top: 100%;
    left: 0;
    right: 0;
    z-index: 99;
    cursor: pointer;
    max-height: 367.5px;
    overflow: auto;
    border: 1px solid var(--color-black);
    border-top: none;

    @media only screen and (min-width: 768px) {
      max-height: unset;
    }
  }
</style>
